/**
 * ⚠️ このコンポーネントはAPSからコピーされています。
 * スタイルや構造を変更した場合は、APS側も必ず同期してください。
 * APS側: repos/aps/packages/frontend/src/components/organisms/notification/notification-detail/NotificationBody.tsx
 *
 * 表示のズレを防ぐため、以下の変更時は特に注意:
 * - Container のスタイル変更（margin, padding, font等）
 * - ReactMarkdown の components prop の変更
 * - breakPoint.ts のメディアクエリ変更
 *
 * See: repos/aps/.claude/rules/frontend/demo-app-sync.md
 */
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import { pc, tablet } from "../../themes/breakPoint";

/**
 * NotificationBody Component
 */

export interface NotificationBodyProps {
  body: string;
}

const imageStyle = `
  max-width: 528px;
  width: 100%;
  vertical-align: middle;
`;

const Container = styled.div`
  font-family:
    "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", "ヒラギノ角ゴ Pro",
    "Hiragino Kaku Gothic Pro", "メイリオ", "Meiryo", sans-serif;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  box-sizing: border-box;
  margin-bottom: 50px;
  p {
    line-height: 1.5;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
  ${tablet`
    p:has(img) {
      text-align: center;
      img {
        ${imageStyle}
      }
    }
    ul:has(> li > img),
    ol:has(> li > img) {
      list-style: none;
      padding-left: 0;
      display: grid;
      grid-template-columns: 1fr;
      gap: 24px;
      li {
        text-align: center;
        img {
          ${imageStyle}
        }
      }
    }
  `}
  ${pc`
    p:has(img) {
      img {
        ${imageStyle}
      }
    }
    ul:has(> li > img),
    ol:has(> li > img) {
      list-style: none;
      padding-left: 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
      li {
        img {
          ${imageStyle}
        }
      }
    }
  `}
  a {
    font-weight: bold;
    color: #50beef;
    text-decoration: none;
  }
  ol,
  ul {
    line-height: 1.5;
    padding-left: 20px;
    margin-bottom: 20px;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
  ul {
    list-style: disc;
  }
  ol {
    list-style: decimal;
  }
  strong {
    font-weight: bold;
  }
`;

export function NotificationBody({ body }: NotificationBodyProps) {
  return (
    <Container>
      <ReactMarkdown
        children={body}
        components={{
          a: ({ node: _node, ...props }) => <a {...props} target="_blank" />,
          img: ({ node: _node, ...props }) => (
            <a href={props.src} target="_blank">
              <img {...props} />
            </a>
          ),
        }}
      />
    </Container>
  );
}
